export default __webpack_public_path__ + "static/media/data-security-image.039b9bf8.webp";